import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UtilitiesService } from 'src/app/common/services/utilities.service';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-dup-dialog-row',
    templateUrl: './dup-dialog-row.component.html',
    styleUrls: ['./dup-dialog-row.component.css']
})
export class DupDialogRowComponent implements OnInit {
    constructor(
        private utilitiesService: UtilitiesService,
        private dataService: DataService
    ) { }

    @Input() rowData: any;
    @Input() controller: string;
    @Input() disabled: boolean = false;
    @Input() apiOptions: any;
    @Input() baseSchedule: { start: Date | null; end: Date | null } = {
        start: null,
        end: null
    };
    @Output() valueChange = new EventEmitter<any>();

    public TTL_OPTIONS = [
        {
            label: '1 hour',
            value: 1,
        },
        {
            label: '2 hours',
            value: 2,
        },
        {
            label: '3 hours',
            value: 3,
        },
        {
            label: '4 hours',
            value: 4,
        },
        {
            label: '5 hours',
            value: 5,
        },
        {
            label: '6 hours',
            value: 6,
        },
        {
            label: '7 hours',
            value: 7,
        },
        {
            label: '8 hours',
            value: 8,
        },
        {
            label: '9 hours',
            value: 9,
        },
        {
            label: '10 hours',
            value: 10,
        },
        {
            label: '11 hours',
            value: 11,
        },
        {
            label: '12 hours',
            value: 12,
        },
        {
            label: '13 hours',
            value: 13,
        },
        {
            label: '14 hours',
            value: 14,
        },
        {
            label: '15 hours',
            value: 15,
        },
        {
            label: '16 hours',
            value: 16,
        },
        {
            label: '17 hours',
            value: 17,
        },
        {
            label: '18 hours',
            value: 18,
        },
        {
            label: '19 hours',
            value: 19,
        },
        {
            label: '20 hours',
            value: 20,
        },
        {
            label: '21 hours',
            value: 21,
        },
        {
            label: '22 hours',
            value: 22,
        },
        {
            label: '23 hours',
            value: 23,
        },
        // Days
        {
            label: '1 day / 24 hours',
            value: 24,
          },
          {
            label: '2 days / 48 hours',
            value: 48,
          },
          {
            label: '3 days / 72 hours',
            value: 72,
          },
          {
            label: '4 days / 96 hours',
            value: 96,
          },
          {
            label: '5 days / 120 hours',
            value: 120,
          },
          {
            label: '6 days / 144 hours',
            value: 144,
          },
          {
            label: '7 days / 168 hours',
            value: 168,
          },
          {
            label: '8 days / 192 hours',
            value: 192,
          },
          {
            label: '9 days / 216 hours',
            value: 216,
          },
          {
            label: '10 days / 240 hours',
            value: 240,
          },
          {
            label: '11 days / 264 hours',
            value: 264,
          },
          {
            label: '12 days / 288 hours',
            value: 288,
          },
          {
            label: '13 days / 312 hours',
            value: 312,
          },
          {
            label: '14 days / 336 hours',
            value: 336,
          },
          {
            label: '15 days / 360 hours',
            value: 360,
          },
          {
            label: '16 days / 384 hours',
            value: 384,
          },
          {
            label: '17 days / 408 hours',
            value: 408,
          },
          {
            label: '18 days / 432 hours',
            value: 432,
          },
          {
            label: '19 days / 456 hours',
            value: 456,
          },
          {
            label: '20 days / 480 hours',
            value: 480,
          },
          {
            label: '21 days / 504 hours',
            value: 504,
          },
    ]

    public LINK_REF_OPTIONS: any[] = [];
    private linkDestinationOptions: any[] = [];

    public ENV_OPTIONS = [
        { label: 'dev', value: 'dev' },
        { label: 'qa', value: 'qa' },
        { label: 'prod', value: 'prod' }
    ]

    async ngOnInit() {
        await this.loadLinkDestinations();
    }

    private async loadLinkDestinations() {
        try {
            // Cargar las opciones de link destination usando el DataService
            const result = await this.dataService.getAllOfTypeAsync('link-destination', {}, false);
            const mappedOptions = result.map((item: any) => ({
                _id: item._id,
                id: item.id,
                linkText: item.linkText,
                linkDestination: item.linkDestination
            }));
            
            this.linkDestinationOptions = mappedOptions;
            
            // Asegurar que apiOptions esté inicializado
            if (!this.apiOptions) {
                this.apiOptions = {};
            }
            
            // Asignar las opciones tanto para el key específico como para link_ref
            if (this.rowData && this.rowData.key) {
                this.apiOptions[this.rowData.key] = mappedOptions;
            }
            this.apiOptions['link_ref'] = mappedOptions;
            
            console.log('Link destinations loaded:', {
                options: mappedOptions,
                apiOptions: this.apiOptions
            });
        } catch (error) {
            console.error('Error loading link destinations:', error);
            this.linkDestinationOptions = [];
            if (this.rowData && this.rowData.key) {
                this.apiOptions[this.rowData.key] = [];
            }
            this.apiOptions['link_ref'] = [];
        }
    }

    getLinkDestinationOptions() {
        return this.linkDestinationOptions;
    }


    onValueChange(value: any, fieldKey?:string) {
        console.log('onValueChange called with:', { value, fieldKey });
        if (!this.disabled) {
            this.valueChange.emit({value, fieldKey});
        }
    }

    resetTimeToMidnight(value: any, event: Event, model: any = null, index: any = null) {
        event.preventDefault();
        
        if (model) {
            if (index !== null && Array.isArray(value)) {
                // Handle array case (multiselectDups)
                const date = new Date(value[index][model]);
                date.setHours(0, 0, 0, 0);
                value[index][model] = date;
            } else {
                // Handle single object case (singleDup)
                const date = new Date(value[model]);
                date.setHours(0, 0, 0, 0);
                value[model] = date;
            }
            this.onValueChange(value);
        } else {
            // Handle direct date value case (dateInput)
            if (value) {
                const date = new Date(value);
                date.setHours(0, 0, 0, 0);
                value = date;
                this.onValueChange(value);
            }
        }
    }

    getFormattedDate(date: any): string {
        return date ? new Date(date).toISOString().split('T')[0] : '';
    }

    getDropdownDisplayText(data: any): string {
        if (!data || !data.options || !data.value) return '';
        
        const options = Array.isArray(data.options[0]) ? data.options[0] : data.options;
        const option = options.find((opt: any) => opt[data.optionValue] === data.value);
        return option ? option[data.optionLabel] : '';
    }

    isDateOutsideRange(date: any): boolean {
        if (!date || !this.baseSchedule.start || !this.baseSchedule.end) {
            return false;
        }

        const compareDate = new Date(date);
        const startDate = new Date(this.baseSchedule.start);
        const endDate = new Date(this.baseSchedule.end);

        const isOutside = compareDate < startDate || compareDate > endDate;

        return isOutside;
    }
} 
